import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ThemeColorChanger = () => {
  const location = useLocation();

  useEffect(() => {
    let color = "#2d366d";
    const viewContainer = document.querySelector('.view-container');
    if (viewContainer?.classList.contains("background-white")) {
      color = "#FFFFFF";
    } else {
      color = "#2d366d";
    }

    document.querySelector("meta[name='theme-color']")?.setAttribute("content", color);
    document.querySelector("meta[name='msapplication-TileColor']")?.setAttribute("content", color);
    
  }, [location]); 
   

  return null;
};

export default ThemeColorChanger;